import {DateTime} from "luxon"
import {isNullOrUndefined} from "@/plugins/object-helpers"
import {phoneFilter} from "@/plugins/filters"

export const patient = {
  state: {
    surname: null,
    forename: null,
    patronymic: null,
    gender: null,
    birthdate: null,
    phone: null,
  },
  mutations: {
    setPatientInfo(state, val) {
      state.surname = val.surname
      state.forename = val.forename
      state.patronymic = val.patronymic
      state.gender = val.gender
      state.birthdate = val.birthdate
      state.phone = val.phone
    },
    clearPatientInfo(state) {
      state.surname = null
      state.forename = null
      state.patronymic = null
      state.gender = null
      state.birthdate = null
      state.phone = null
    }
  },
  getters: {
    patientSurname(state) {
      return state.surname
    },
    patientForename(state) {
      return state.forename
    },
    patientPatronymic(state) {
      return state.patronymic
    },
    patientGender(state) {
      return state.gender
    },
    patientBirthdate(state) {
      return state.birthdate
    },
    patientBirthdateFormatted(state) {
      if (!isNullOrUndefined(state.birthdate)) {
        return DateTime.fromFormat(state.birthdate, 'yyyy-MM-dd').toFormat('dd.MM.yyyy')
      }
      return ''
    },
    patientPhone(state) {
      return state.phone
    },
    patientPhoneFormatted(state) {
      return phoneFilter(state.phone)
    },
    patientFio(state) {
      return `${state.surname} ${state.forename} ${state.patronymic}`
    },
    patientInfo(state) {
      let birthdateString = ''
      if (!isNullOrUndefined(state.birthdate)) {
        birthdateString = DateTime.fromFormat(state.birthdate, 'yyyy-MM-dd').toFormat('dd.MM.yyyy')
      }
      let fio = `${state.surname} ${state.forename} ${state.patronymic}`
      return `${fio} (${birthdateString})`
    },
  }
}